import React, { FC } from "react";
import { RouteComponentProps } from "@reach/router";

const PublicRoute: FC<RouteComponentProps> = ({ children }) => {
  return <>{children}</>;
};

export default PublicRoute;
